export enum IncotermsEnum {
  CFR = 'CFR',
  CIF = 'CIF',
  CPT = 'CPT',
  DAP = 'DAP',
  EXW = 'EXW',
  FCA = 'FCA',
  CIP = 'CIP',
  FOB = 'FOB',
  FAS = 'FAS',
}
